var _g, _g2, _path, _path2, _path3, _path4, _rect, _path5, _g3, _g4, _g5, _path6, _g6, _g7, _g8, _g9, _path7, _g10, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInterop = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 581,
    height: 320,
    viewBox: "0 0 581 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_95_5893)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 410,
    cy: 160,
    r: 160,
    fill: "url(#paint0_linear_95_5893)",
    fillOpacity: 0.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_95_5893)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 160,
    r: 160,
    fill: "url(#paint1_linear_95_5893)",
    fillOpacity: 0.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M277.171 154.726L270.43 160.624C270.202 160.823 270.202 161.177 270.43 161.376L277.171 167.274C277.494 167.557 278 167.328 278 166.898V155.102C278 154.672 277.494 154.443 277.171 154.726Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M302.829 167.274L309.57 161.376C309.798 161.177 309.798 160.823 309.57 160.624L302.829 154.726C302.506 154.443 302 154.672 302 155.102L302 166.898C302 167.328 302.506 167.557 302.829 167.274Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M129.399 58.71H131.429C131.429 60.18 132.339 60.74 133.529 60.74C134.929 60.74 135.559 60.11 135.559 59.27C135.559 58.64 135.139 58.01 133.319 58.01C130.379 58.01 129.539 56.89 129.539 55.56C129.539 53.95 130.869 52.69 133.529 52.69C136.749 52.69 137.379 54.37 137.379 55.7H135.349C135.349 54.86 134.859 54.16 133.459 54.16C132.129 54.16 131.639 54.79 131.639 55.42C131.639 56.05 132.269 56.47 133.739 56.47C136.539 56.47 137.659 57.45 137.659 59.06C137.659 61.09 135.979 62.21 133.529 62.21C130.659 62.21 129.399 60.81 129.399 58.71ZM138.219 58.5C138.219 56.47 139.339 54.79 141.859 54.79C144.379 54.79 145.499 56.47 145.499 58.5C145.499 60.53 144.379 62.21 141.859 62.21C139.339 62.21 138.219 60.53 138.219 58.5ZM140.109 58.5C140.109 60.32 140.949 60.95 141.859 60.95C142.769 60.95 143.609 60.32 143.609 58.5C143.609 56.68 142.769 56.05 141.859 56.05C140.949 56.05 140.109 56.68 140.109 58.5ZM151.093 55H152.913V62H151.093V60.67C151.093 60.67 150.113 62.21 148.573 62.21C146.893 62.21 146.193 61.16 146.193 59.62V55H148.013V59.13C148.013 60.32 148.503 60.74 149.343 60.74C150.183 60.74 151.093 60.11 151.093 58.5V55ZM155.574 62H153.754V55H155.574V56.876C155.602 56.778 156.316 54.86 157.954 54.86H158.164V56.75H157.674C156.694 56.75 155.574 57.31 155.574 59.13V62ZM160.412 58.5C160.412 60.39 161.252 60.95 162.162 60.95C163.002 60.95 163.632 60.39 163.702 59.34H165.592C165.522 60.88 164.472 62.21 162.162 62.21C159.712 62.21 158.522 60.53 158.522 58.5C158.522 56.47 159.712 54.79 162.162 54.79C164.472 54.79 165.522 56.12 165.592 57.66H163.702C163.632 56.61 163.002 56.05 162.162 56.05C161.252 56.05 160.412 56.61 160.412 58.5ZM173.221 58.85H168.055C168.139 60.404 168.881 60.95 169.861 60.95C170.701 60.95 171.191 60.39 171.331 59.69H173.151C172.871 61.02 171.961 62.21 169.791 62.21C167.341 62.21 166.151 60.53 166.151 58.5C166.151 56.47 167.341 54.79 169.791 54.79C171.961 54.79 173.221 56.19 173.221 58.29V58.85ZM169.791 56.05C169.035 56.05 168.321 56.442 168.097 57.66H171.331C171.261 56.54 170.631 56.05 169.791 56.05ZM178.683 57.45C178.683 59.9 179.803 60.74 181.133 60.74C182.463 60.74 183.233 60.04 183.373 58.71H185.473C185.403 60.6 184.017 62.21 181.133 62.21C178.123 62.21 176.583 60.18 176.583 57.45C176.583 54.72 178.123 52.69 181.133 52.69C184.003 52.69 185.403 54.3 185.473 56.19H183.373C183.233 54.93 182.463 54.16 181.133 54.16C179.803 54.16 178.683 55 178.683 57.45ZM187.99 62H186.17V52.9H187.99V56.33C187.99 56.33 188.97 54.79 190.51 54.79C192.19 54.79 192.89 55.84 192.89 57.38V62H191.07V57.87C191.07 56.68 190.58 56.26 189.74 56.26C188.9 56.26 187.99 56.89 187.99 58.5V62ZM193.661 57.1C193.661 55.63 194.921 54.79 196.811 54.79C198.981 54.79 200.101 55.49 200.101 57.03V60.25C200.101 61.65 200.451 61.93 200.451 61.93V62H198.491C198.491 62 198.281 61.86 198.281 61.02V60.95C198.281 60.95 197.581 62.21 195.901 62.21C194.221 62.21 193.521 61.16 193.521 59.97C193.521 58.57 194.431 57.66 196.741 57.66C198.141 57.66 198.281 57.31 198.281 56.96C198.281 56.47 197.931 56.05 196.881 56.05C195.691 56.05 195.481 56.61 195.481 57.1H193.661ZM198.281 58.99V58.374C198.267 58.388 197.833 58.85 196.601 58.85C195.691 58.85 195.271 59.27 195.271 59.83C195.271 60.53 195.691 60.88 196.461 60.88C197.301 60.88 198.281 60.32 198.281 58.99ZM201.004 54.44V52.9H202.824V54.44H201.004ZM201.004 62V55H202.824V62H201.004ZM205.49 62H203.67V55H205.49V56.33C205.49 56.33 206.47 54.79 208.01 54.79C209.69 54.79 210.39 55.84 210.39 57.38V62H208.57V57.87C208.57 56.68 208.08 56.26 207.24 56.26C206.4 56.26 205.49 56.89 205.49 58.5V62Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M357.511 62V52.9H360.731C363.811 52.9 365.701 54.44 365.701 57.45C365.701 60.46 363.811 62 360.731 62H357.511ZM359.401 60.46H360.871C362.201 60.46 363.601 59.76 363.601 57.45C363.601 55.14 362.201 54.44 360.871 54.44H359.401V60.46ZM373.328 58.85H368.162C368.246 60.404 368.988 60.95 369.968 60.95C370.808 60.95 371.298 60.39 371.438 59.69H373.258C372.978 61.02 372.068 62.21 369.898 62.21C367.448 62.21 366.258 60.53 366.258 58.5C366.258 56.47 367.448 54.79 369.898 54.79C372.068 54.79 373.328 56.19 373.328 58.29V58.85ZM369.898 56.05C369.142 56.05 368.428 56.442 368.204 57.66H371.438C371.368 56.54 370.738 56.05 369.898 56.05ZM373.816 59.69H375.706C375.706 60.53 376.336 60.95 377.246 60.95C378.436 60.95 378.716 60.32 378.716 59.83C378.716 59.34 378.436 58.92 376.966 58.92C374.796 58.92 373.956 58.22 373.956 56.96C373.956 55.77 375.006 54.79 377.176 54.79C379.976 54.79 380.326 56.33 380.326 57.1H378.506C378.506 56.54 378.156 56.05 377.106 56.05C376.126 56.05 375.776 56.54 375.776 56.89C375.776 57.24 375.986 57.66 377.386 57.66C379.416 57.66 380.606 58.15 380.606 59.76C380.606 61.09 379.556 62.21 377.246 62.21C374.656 62.21 373.816 60.95 373.816 59.69ZM380.818 56.4V55H382.218V52.9H384.038V55H385.578V56.4H384.038V59.97C384.038 60.6 384.248 60.74 384.738 60.74C385.018 60.74 385.578 60.67 385.578 60.67V62C385.578 62 384.668 62.14 384.038 62.14C382.568 62.14 382.218 61.65 382.218 59.97V56.4H380.818ZM386.345 54.44V52.9H388.165V54.44H386.345ZM386.345 62V55H388.165V62H386.345ZM390.831 62H389.011V55H390.831V56.33C390.831 56.33 391.811 54.79 393.351 54.79C395.031 54.79 395.731 55.84 395.731 57.38V62H393.911V57.87C393.911 56.68 393.421 56.26 392.581 56.26C391.741 56.26 390.831 56.89 390.831 58.5V62ZM396.501 57.1C396.501 55.63 397.761 54.79 399.651 54.79C401.821 54.79 402.941 55.49 402.941 57.03V60.25C402.941 61.65 403.291 61.93 403.291 61.93V62H401.331C401.331 62 401.121 61.86 401.121 61.02V60.95C401.121 60.95 400.421 62.21 398.741 62.21C397.061 62.21 396.361 61.16 396.361 59.97C396.361 58.57 397.271 57.66 399.581 57.66C400.981 57.66 401.121 57.31 401.121 56.96C401.121 56.47 400.771 56.05 399.721 56.05C398.531 56.05 398.321 56.61 398.321 57.1H396.501ZM401.121 58.99V58.374C401.107 58.388 400.673 58.85 399.441 58.85C398.531 58.85 398.111 59.27 398.111 59.83C398.111 60.53 398.531 60.88 399.301 60.88C400.141 60.88 401.121 60.32 401.121 58.99ZM403.431 56.4V55H404.831V52.9H406.651V55H408.191V56.4H406.651V59.97C406.651 60.6 406.861 60.74 407.351 60.74C407.631 60.74 408.191 60.67 408.191 60.67V62C408.191 62 407.281 62.14 406.651 62.14C405.181 62.14 404.831 61.65 404.831 59.97V56.4H403.431ZM408.958 54.44V52.9H410.778V54.44H408.958ZM408.958 62V55H410.778V62H408.958ZM411.484 58.5C411.484 56.47 412.604 54.79 415.124 54.79C417.644 54.79 418.764 56.47 418.764 58.5C418.764 60.53 417.644 62.21 415.124 62.21C412.604 62.21 411.484 60.53 411.484 58.5ZM413.374 58.5C413.374 60.32 414.214 60.95 415.124 60.95C416.034 60.95 416.874 60.32 416.874 58.5C416.874 56.68 416.034 56.05 415.124 56.05C414.214 56.05 413.374 56.68 413.374 58.5ZM421.278 62H419.458V55H421.278V56.33C421.278 56.33 422.258 54.79 423.798 54.79C425.478 54.79 426.178 55.84 426.178 57.38V62H424.358V57.87C424.358 56.68 423.868 56.26 423.028 56.26C422.188 56.26 421.278 56.89 421.278 58.5V62ZM431.781 57.45C431.781 59.9 432.901 60.74 434.231 60.74C435.561 60.74 436.331 60.04 436.471 58.71H438.571C438.501 60.6 437.115 62.21 434.231 62.21C431.221 62.21 429.681 60.18 429.681 57.45C429.681 54.72 431.221 52.69 434.231 52.69C437.101 52.69 438.501 54.3 438.571 56.19H436.471C436.331 54.93 435.561 54.16 434.231 54.16C432.901 54.16 431.781 55 431.781 57.45ZM441.089 62H439.269V52.9H441.089V56.33C441.089 56.33 442.069 54.79 443.609 54.79C445.289 54.79 445.989 55.84 445.989 57.38V62H444.169V57.87C444.169 56.68 443.679 56.26 442.839 56.26C441.999 56.26 441.089 56.89 441.089 58.5V62ZM446.759 57.1C446.759 55.63 448.019 54.79 449.909 54.79C452.079 54.79 453.199 55.49 453.199 57.03V60.25C453.199 61.65 453.549 61.93 453.549 61.93V62H451.589C451.589 62 451.379 61.86 451.379 61.02V60.95C451.379 60.95 450.679 62.21 448.999 62.21C447.319 62.21 446.619 61.16 446.619 59.97C446.619 58.57 447.529 57.66 449.839 57.66C451.239 57.66 451.379 57.31 451.379 56.96C451.379 56.47 451.029 56.05 449.979 56.05C448.789 56.05 448.579 56.61 448.579 57.1H446.759ZM451.379 58.99V58.374C451.365 58.388 450.931 58.85 449.699 58.85C448.789 58.85 448.369 59.27 448.369 59.83C448.369 60.53 448.789 60.88 449.559 60.88C450.399 60.88 451.379 60.32 451.379 58.99ZM454.103 54.44V52.9H455.923V54.44H454.103ZM454.103 62V55H455.923V62H454.103ZM458.589 62H456.769V55H458.589V56.33C458.589 56.33 459.569 54.79 461.109 54.79C462.789 54.79 463.489 55.84 463.489 57.38V62H461.669V57.87C461.669 56.68 461.179 56.26 460.339 56.26C459.499 56.26 458.589 56.89 458.589 58.5V62Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 278,
    y: 160,
    width: 24,
    height: 2,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 162H88.5M88.5 162L33 75M88.5 162L33 246.5",
    stroke: "#585863",
    strokeOpacity: 0.7,
    strokeDasharray: "2 2"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 3,
    y: 44,
    width: 60,
    height: 60
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(10px)",
      clipPath: "url(#bgblur_0_95_5893_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_95_5893)",
    "data-figma-bg-blur-radius": 20
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 74,
    r: 10,
    fill: "url(#paint2_linear_95_5893)",
    fillOpacity: 0.6
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 3,
    y: 216,
    width: 60,
    height: 60
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(10px)",
      clipPath: "url(#bgblur_1_95_5893_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_95_5893)",
    "data-figma-bg-blur-radius": 20
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 246,
    r: 10,
    fill: "url(#paint3_linear_95_5893)",
    fillOpacity: 0.6
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: -20,
    y: 132,
    width: 60,
    height: 60
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(10px)",
      clipPath: "url(#bgblur_2_95_5893_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_95_5893)",
    "data-figma-bg-blur-radius": 20
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 162,
    r: 10,
    fill: "url(#paint4_linear_95_5893)",
    fillOpacity: 0.6
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M571.001 162H492.501M492.501 162L548.001 75M492.501 162L548.001 246.5",
    stroke: "#585863",
    strokeOpacity: 0.7,
    strokeDasharray: "2 2"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 518,
    y: 44,
    width: 60,
    height: 60
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(10px)",
      clipPath: "url(#bgblur_3_95_5893_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_95_5893)",
    "data-figma-bg-blur-radius": 20
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    transform: "matrix(-1 0 0 1 558 64)",
    fill: "url(#paint5_linear_95_5893)",
    fillOpacity: 0.6
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 518,
    y: 216,
    width: 60,
    height: 60
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(10px)",
      clipPath: "url(#bgblur_4_95_5893_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_i_95_5893)",
    "data-figma-bg-blur-radius": 20
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    transform: "matrix(-1 0 0 1 558 236)",
    fill: "url(#paint6_linear_95_5893)",
    fillOpacity: 0.6
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 541,
    y: 132,
    width: 60,
    height: 60
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(10px)",
      clipPath: "url(#bgblur_5_95_5893_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_i_95_5893)",
    "data-figma-bg-blur-radius": 20
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    transform: "matrix(-1 0 0 1 581 152)",
    fill: "url(#paint7_linear_95_5893)",
    fillOpacity: 0.6
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_i_95_5893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.961 136.424C328.591 134.954 330.037 134 331.638 134H487C502.464 134 515 146.536 515 162C515 177.464 502.464 190 487 190H311.066C308.195 190 306.258 187.064 307.39 184.424L327.961 136.424Z",
    fill: "#F4234D"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M380.719 167V159.88L378.319 167H376.079L373.679 159.88V167H371.519V156.6H374.559L377.199 164.52L379.839 156.6H382.879V167H380.719ZM391.752 163.4H385.848C385.944 165.176 386.792 165.8 387.912 165.8C388.872 165.8 389.432 165.16 389.592 164.36H391.672C391.352 165.88 390.312 167.24 387.832 167.24C385.032 167.24 383.672 165.32 383.672 163C383.672 160.68 385.032 158.76 387.832 158.76C390.312 158.76 391.752 160.36 391.752 162.76V163.4ZM387.832 160.2C386.968 160.2 386.152 160.648 385.896 162.04H389.592C389.512 160.76 388.792 160.2 387.832 160.2ZM392.55 167V156.6H394.63V167H392.55ZM395.597 167V156.6H397.677V167H395.597ZM398.484 163C398.484 160.68 399.764 158.76 402.644 158.76C405.524 158.76 406.804 160.68 406.804 163C406.804 165.32 405.524 167.24 402.644 167.24C399.764 167.24 398.484 165.32 398.484 163ZM400.644 163C400.644 165.08 401.604 165.8 402.644 165.8C403.684 165.8 404.644 165.08 404.644 163C404.644 160.92 403.684 160.2 402.644 160.2C401.604 160.2 400.644 160.92 400.644 163ZM415.285 165L416.565 159H418.725L416.725 167H414.085L412.805 161.64L411.525 167H408.885L406.885 159H409.045L410.325 165L411.765 159H413.845L415.285 165ZM419.125 161.8C419.125 158.68 421.045 156.36 424.405 156.36C427.765 156.36 429.685 158.68 429.685 161.8C429.685 164.92 427.765 167.24 424.405 167.24C421.045 167.24 419.125 164.92 419.125 161.8ZM421.525 161.8C421.525 164.52 422.885 165.56 424.405 165.56C425.925 165.56 427.285 164.52 427.285 161.8C427.285 159.08 425.925 158.04 424.405 158.04C422.885 158.04 421.525 159.08 421.525 161.8ZM430.488 167V156.6H438.648V158.36H432.648V160.92H437.448V162.68H432.648V167H430.488ZM448.641 156.6V158.36H445.041V167H442.881V158.36H439.281V156.6H448.641Z",
    fill: "white"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_i_95_5893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65 162C65 146.536 77.536 134 93 134H268.934C271.805 134 273.742 136.936 272.61 139.576L252.039 187.576C251.409 189.046 249.963 190 248.362 190H93C77.536 190 65 177.464 65 162Z",
    fill: "#F4234D"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M113.899 167V159.88L111.499 167H109.259L106.859 159.88V167H104.699V156.6H107.739L110.379 164.52L113.019 156.6H116.059V167H113.899ZM124.931 163.4H119.027C119.123 165.176 119.971 165.8 121.091 165.8C122.051 165.8 122.611 165.16 122.771 164.36H124.851C124.531 165.88 123.491 167.24 121.011 167.24C118.211 167.24 116.851 165.32 116.851 163C116.851 160.68 118.211 158.76 121.011 158.76C123.491 158.76 124.931 160.36 124.931 162.76V163.4ZM121.011 160.2C120.147 160.2 119.331 160.648 119.075 162.04H122.771C122.691 160.76 121.971 160.2 121.011 160.2ZM125.73 167V156.6H127.81V167H125.73ZM128.777 167V156.6H130.857V167H128.777ZM131.664 163C131.664 160.68 132.944 158.76 135.824 158.76C138.704 158.76 139.984 160.68 139.984 163C139.984 165.32 138.704 167.24 135.824 167.24C132.944 167.24 131.664 165.32 131.664 163ZM133.824 163C133.824 165.08 134.784 165.8 135.824 165.8C136.864 165.8 137.824 165.08 137.824 163C137.824 160.92 136.864 160.2 135.824 160.2C134.784 160.2 133.824 160.92 133.824 163ZM148.464 165L149.744 159H151.904L149.904 167H147.264L145.984 161.64L144.704 167H142.064L140.064 159H142.224L143.504 165L144.944 159H147.024L148.464 165ZM152.304 161.8C152.304 158.68 154.224 156.36 157.584 156.36C160.944 156.36 162.864 158.68 162.864 161.8C162.864 164.92 160.944 167.24 157.584 167.24C154.224 167.24 152.304 164.92 152.304 161.8ZM154.704 161.8C154.704 164.52 156.064 165.56 157.584 165.56C159.104 165.56 160.464 164.52 160.464 161.8C160.464 159.08 159.104 158.04 157.584 158.04C156.064 158.04 154.704 159.08 154.704 161.8ZM163.668 167V156.6H171.828V158.36H165.828V160.92H170.628V162.68H165.828V167H163.668ZM181.821 156.6V158.36H178.221V167H176.061V158.36H172.461V156.6H181.821ZM188.221 167L187.405 164.68H183.437L182.621 167H180.221L184.221 156.6H186.621L190.621 167H188.221ZM185.421 159.08L184.061 162.92H186.781L185.421 159.08ZM196.781 156.6H198.861V167H196.781V165.64C196.781 165.64 195.981 167.24 194.061 167.24C192.141 167.24 190.461 165.88 190.461 163C190.461 160.12 192.141 158.76 194.061 158.76C195.981 158.76 196.781 160.2 196.781 160.2V156.6ZM192.621 163C192.621 165 193.661 165.8 194.701 165.8C195.741 165.8 196.781 165 196.781 163C196.781 161 195.741 160.2 194.701 160.2C193.661 160.2 192.621 161 192.621 163ZM199.744 161.4C199.744 159.72 201.184 158.76 203.344 158.76C205.824 158.76 207.104 159.56 207.104 161.32V165C207.104 166.6 207.504 166.92 207.504 166.92V167H205.264C205.264 167 205.024 166.84 205.024 165.88V165.8C205.024 165.8 204.224 167.24 202.304 167.24C200.384 167.24 199.584 166.04 199.584 164.68C199.584 163.08 200.624 162.04 203.264 162.04C204.864 162.04 205.024 161.64 205.024 161.24C205.024 160.68 204.624 160.2 203.424 160.2C202.064 160.2 201.824 160.84 201.824 161.4H199.744ZM205.024 163.56V162.856C205.008 162.872 204.512 163.4 203.104 163.4C202.064 163.4 201.584 163.88 201.584 164.52C201.584 165.32 202.064 165.72 202.944 165.72C203.904 165.72 205.024 165.08 205.024 163.56ZM210.216 169.4H208.136V159H210.216V160.36C210.216 160.36 211.016 158.76 212.936 158.76C214.856 158.76 216.536 160.12 216.536 163C216.536 165.88 214.856 167.24 212.936 167.24C211.016 167.24 210.216 165.8 210.216 165.8V169.4ZM214.376 163C214.376 161 213.336 160.2 212.296 160.2C211.256 160.2 210.216 161 210.216 163C210.216 165 211.256 165.8 212.296 165.8C213.336 165.8 214.376 165 214.376 163ZM216.695 160.6V159H218.295V156.6H220.375V159H222.135V160.6H220.375V164.68C220.375 165.4 220.615 165.56 221.175 165.56C221.495 165.56 222.135 165.48 222.135 165.48V167C222.135 167 221.095 167.16 220.375 167.16C218.695 167.16 218.295 166.6 218.295 164.68V160.6H216.695ZM230.619 163.4H224.715C224.811 165.176 225.659 165.8 226.779 165.8C227.739 165.8 228.299 165.16 228.459 164.36H230.539C230.219 165.88 229.179 167.24 226.699 167.24C223.899 167.24 222.539 165.32 222.539 163C222.539 160.68 223.899 158.76 226.699 158.76C229.179 158.76 230.619 160.36 230.619 162.76V163.4ZM226.699 160.2C225.835 160.2 225.019 160.648 224.763 162.04H228.459C228.379 160.76 227.659 160.2 226.699 160.2ZM233.498 167H231.418V159H233.498V161.144C233.53 161.032 234.346 158.84 236.218 158.84H236.458V161H235.898C234.778 161 233.498 161.64 233.498 163.72V167Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_95_5893",
    x: 250,
    y: 0,
    width: 320,
    height: 320,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_95_5893"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_95_5893",
    x: 10,
    y: 0,
    width: 320,
    height: 320,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_95_5893"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_95_5893",
    x: 3,
    y: 44,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.971143 0 0 0 0 0.971143 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_95_5893"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_95_5893_clip_path",
    transform: "translate(-3 -44)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 74,
    r: 10
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_95_5893",
    x: 3,
    y: 216,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.971143 0 0 0 0 0.971143 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_95_5893"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_95_5893_clip_path",
    transform: "translate(-3 -216)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 246,
    r: 10
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_95_5893",
    x: -20,
    y: 132,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.971143 0 0 0 0 0.971143 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_95_5893"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_2_95_5893_clip_path",
    transform: "translate(20 -132)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 162,
    r: 10
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_95_5893",
    x: 518,
    y: 44,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.971143 0 0 0 0 0.971143 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_95_5893"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_3_95_5893_clip_path",
    transform: "translate(-518 -44)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    transform: "matrix(-1 0 0 1 558 64)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_i_95_5893",
    x: 518,
    y: 216,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.971143 0 0 0 0 0.971143 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_95_5893"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_4_95_5893_clip_path",
    transform: "translate(-518 -216)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    transform: "matrix(-1 0 0 1 558 236)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_i_95_5893",
    x: 541,
    y: 132,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.971143 0 0 0 0 0.971143 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_95_5893"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_5_95_5893_clip_path",
    transform: "translate(-541 -132)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    transform: "matrix(-1 0 0 1 581 152)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_i_95_5893",
    x: 307.062,
    y: 134,
    width: 207.938,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.85
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_95_5893"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_i_95_5893",
    x: 65,
    y: 134,
    width: 207.938,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.85
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_95_5893"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_95_5893",
    x1: 410,
    y1: 0,
    x2: 410,
    y2: 320,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B3D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18191F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_95_5893",
    x1: 170,
    y1: 0,
    x2: 170,
    y2: 320,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18191F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B3D4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_95_5893",
    x1: 33,
    y1: 64,
    x2: 33,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5061"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2D38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_95_5893",
    x1: 33,
    y1: 236,
    x2: 33,
    y2: 256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5061"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2D38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_95_5893",
    x1: 10,
    y1: 152,
    x2: 10,
    y2: 172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5061"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2D38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_95_5893",
    x1: 10,
    y1: 0,
    x2: 10,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5061"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2D38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_95_5893",
    x1: 10,
    y1: 0,
    x2: 10,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5061"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2D38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_95_5893",
    x1: 10,
    y1: 0,
    x2: 10,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5061"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2D38"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInterop);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/interop.89dbbea52d9d209f044fad73d85e98b6.svg";